import { render } from "./UserCareerGameLevel.vue?vue&type=template&id=5cc9530a&scoped=true&ts=true"
import script from "./UserCareerGameLevel.vue?vue&type=script&lang=ts"
export * from "./UserCareerGameLevel.vue?vue&type=script&lang=ts"

import "./UserCareerGameLevel.vue?vue&type=style&index=0&id=5cc9530a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc9530a"]])

export default __exports__